/**
 * Adzuki global
 * Code in here is used globally
 */

(function Global($, Adzuki)
{
	"use strict";
	var executeSearch, debounce;

	/**
	 * ADZ-8420: POST to a url by building and submitting a form.
	 *
	 * A state-changing action must not sit behind a GET link. Anything that merely follows
	 * a url - a crawler, a link prefetcher, a security scanner, a pasted link, a browser
	 * replaying history - performs the mutation with no intent behind it. Posting means
	 * those arrive as GETs and the controller can refuse them.
	 *
	 * Used by .post-link here and by CustomConfirm.link() for the data-method="post" case,
	 * so there is one implementation rather than two that must agree.
	 */
	Adzuki.postTo = function postTo(url)
	{
		$('<form>', {
			method: 'post',
			action: url
		}).appendTo('body').submit();
	};

	// set global selectpicker defaults
	if ($.fn.selectpicker) {
		$.fn.selectpicker.Constructor.BootstrapVersion  = '3';
		$.fn.selectpicker.Constructor.DEFAULTS.width    = '100%';
		$.fn.selectpicker.Constructor.DEFAULTS.iconBase = Adzuki.Icons.style.regular;
		$.fn.selectpicker.Constructor.DEFAULTS.tickIcon = Adzuki.Icons.check_square.class;
	}

	// add data-* attributes to the div whitelist for tooltip/popovers
	// bug in bootstrap 3.4.1 and 4.3.1
	// see https://github.com/twbs/bootstrap/issues/28290
	if ($.fn.tooltip) {
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.div.push(/^data-[\w-]+/);
	}

	$(document).ready(function documentReady()
	{
		// init tooltips
		if (Adzuki.is_mobile) {
			$('body').tooltip({
				selector: '[data-toggle="tooltip_help"]'
			});
		} else {
			$('body').tooltip({
				selector: '[data-toggle^="tooltip"]'
			});
		}

		// hide a tooltip once its element is clicked: the click focuses the element, and the
		// focus trigger would otherwise keep the tooltip up (MEDIA-336). Capture phase, so it
		// runs before a Vue handler can re-render the element out of the page
		document.addEventListener('click', function hideClickedTooltip(event)
		{
			var element = event.target.closest ? event.target.closest('[data-toggle^="tooltip"]') : null;
			var tooltip;

			if (!element) {
				return;
			}

			// Bootstrap 5 (Trip Summary) keeps the instance on its own registry, 3 and 4 in jQuery data
			if (window.bootstrap && window.bootstrap.Tooltip && window.bootstrap.Tooltip.getInstance) {
				tooltip = window.bootstrap.Tooltip.getInstance(element);
			} else {
				tooltip = $(element).data('bs.tooltip');
			}

			if (tooltip) {
				tooltip.hide();
			}
		}, true);

		// Fix for transitions loading on pageload in chrome
		$('body').removeClass("preload");

		// init collapse
		// $('body').collapse({
		// 	selector: '[data-toggle^="collapse"]'
		// });

		// init autoheight textareas
		if ($('textarea.autoheight').length) {
			Adzuki.TextareaAutoheight($('textarea.autoheight'));
		}

		// init global search
		initGlobalSearch();

		// init alert defaults
		// jconfirm.pluginDefaults = $.extend(jconfirm.pluginDefaults, {
		// 	animation         : 'opacity',
		// 	animateFromElement: false,
		// 	backgroundDismiss : true,
		// 	theme             : 'bootstrap',
		// 	onOpenBefore      : function _applyAdzukiStyle() {
		// 		this.$body.addClass('adzuki-status confirm');
		// 	}
		// });

		// valhooks for bootstrap-select compatibility
		// div's don't normally have have a .val() method because it doesn't
		// make any sense. however, bootstrap-select/jquery has issues with
		// .val() finding the correct value for the input, so this hook provides
		// a .val getter/setter that only works on .bootstrap-select divs
		$.valHooks['div'] = {
			get: function getSelectVal(el) {
				if (el.classList.contains('bootstrap-select')) {
					console.warn('[CODE WARNING] - you should read the select element directly');
					return $(el).find('select').val();
				}

				// default return "value" for a div
				return "";
			},
			set: function setSelectVal(el, val) {
				var $el;
				if (el.classList.contains('bootstrap-select')) {
					$el = $(el);

					// sets select value, doesnt refresh ui for some reason
					$el.selectpicker('val', val);

					// this only works to refresh the ui after a delay,
					// doesn't matter how much of a delay, for some reason
					setTimeout(function refreshSelectUI() {
						$el.find('select').trigger('changed.bs.select', {
							// event handler looks for this to determine
							// whether or not to manually refresh the ui,
							// otherwise it gets ignored
							programmatic: true,
						});
					}, 1);
				}
			}
		};

		// allow optgroup headers in bootstrap-select to select all in the group
		$(document).on('shown.bs.select', function optgroupSelectAll(e) {
			var $select    = $(e.target),
				$bs_select = $select.parents('.bootstrap-select');

			// add click handler to headers to select all in its optgroup
			$bs_select.find('li.dropdown-header:not(.optgroup-select-all)')
				.on('click', function selectAllInGroup()
				{
					var optgroup_label = $(this).find('span').text();

					// values to set
					var option_vals = [];

					// existing checked options
					var existing_vals = $.makeArray($select.find('option:selected').map(function getExistingOptionIds() {
						return this.value;
					}));

					// options in the selected optgroup
					var optgroup_vals = $.makeArray($select.find('optgroup[label="'+optgroup_label+'"] option').map(function getOptionIds() {
						return this.value;
					}));


					if (this.classList.contains('checked')) {
						// uncheck options in this optgroup
						option_vals = existing_vals.filter(function removeOptgroupVals(val, index) {
							return !optgroup_vals.includes(val);
						});

						this.classList.remove('checked');
					}
					else {
						// check options in this optgroup
						option_vals = option_vals.concat(existing_vals, optgroup_vals);
						this.classList.add('checked');
					}

					// set options
					// supposed to update UI, but doesn't :(
					$select.selectpicker('val', option_vals);

					// works, but its stupid to hide the dropdown immediately
					$select.selectpicker('toggle');

					// works, but wipes this custom optgroup select-all feature
					// $select.selectpicker('refresh');

					// doesn't update UI to reflect newly checked options
					// $select.trigger('change');
					// $bs_select.trigger('change');
					// $select.triggerNative('change');
					// $bs_select.triggerNative('change');

				})
				.addClass('optgroup-select-all');
		});

		// init client side table-sorter
		if ($('.table-sort-js').length) {
			$('.table-sort-js').each(function onEachSortableTable(i, table) {
				Adzuki.TableSorter.initClientSide($(table));
			});
		}

		// init server side table-sorter
		if ($('.table-sort').length) {
			$('.table-sort').each(function onEachSortableTable(i, table) {
				Adzuki.TableSorter.initServerSide($(table));
			});
		}

		// handle simple confirmation links
		$(document).on('click', '.confirm-link', function confirmLink(event) {
			event.preventDefault();
			Adzuki.CustomConfirm.link($(this));
			return false;
		});

		// ADZ-8420: state-changing links that post without a confirmation dialog. For
		// actions where the click itself is the intent and a dialog would only be noise -
		// a reversible per-row toggle, say. Anything that costs money or sends mail should
		// use .confirm-link with data-method="post" instead.
		$(document).on('click', '.post-link', function postLink(event) {
			event.preventDefault();
			Adzuki.postTo($(this).attr('href'));
			return false;
		});

		// Chat with care stuff
		if (
			Adzuki.app === 'Erez' ||
			Adzuki.app === 'Esource' ||
			Adzuki.app === 'WebProgram'
		) {
			$('.chat_with_care').click(function _chatWithCare(e) {
				e.preventDefault();

				if (window.fdWidget && typeof window.fdWidget.open === 'function') {
					window.fdWidget.open();
				}
			});
		}

		// submit a ticket
		$('.submit-ticket').on('click', function _takeScreenshot(e) {
			var base64URL  = '',
				support_id  = $(this).data('support-id'),
				environment = $(this).data('environment'),
				$modal      = $('.modal'),
				resolution;

			e.preventDefault();

			if (Adzuki.is_mobile) {
				Adzuki.Ajax.get('/Freshdesk/createTicket/' + support_id + '/' + environment + '/' + resolution)
					.then(function _letsGetEmTagged(content) {
						$modal.find('.modal-title').text("Email Care Team");
						$modal.find('.modal-body').html(content);

						Adzuki.Form.initAjaxForm('FreshdeskCreateTicket');
						Adzuki.DragDropUpload.init($('#freshdeskcreateticket-files'));
						Adzuki.DragDropUpload.start($(".file-upload-options"));

						$('.submit-ticket').html('<i class="adzicon-event_ticket fas fa-fw fa-ticket-alt"></i> Email Care Team');

						$modal.on('hidden.bs.modal', function _restoreModal() {
							$modal.removeClass('wide').off('hidden.bs.modal');
						}).modal('show');
					});
			} else {
				resolution = screen.width + 'x' + screen.height;

				$('.submit-ticket').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin"></i>&nbsp;Taking screenshot...');

				html2canvas(document.body, { // eslint-disable-line no-undef
					height      : window.outerHeight + window.innerHeight,
					windowHeight: window.outerHeight + window.innerHeight
				}).then(function _captureScreenshot(canvas) { // eslint-disable-line no-undef
					document.body.appendChild(canvas);
					base64URL = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream');

					Adzuki.Ajax.post(
						'/main/processScreenshot/',
						{
							image     : base64URL,
							support_id: support_id
						}
					).then(function success(response) {
						document.body.removeChild(canvas);

						if (response.saved === true) {
							Adzuki.Ajax.get('/Freshdesk/createTicket/' + support_id + '/' + environment + '/' + resolution)
								.then(function _letsGetEmTagged(content) {
									$modal.find('.modal-title').text("Email Care Team");
									$modal.find('.modal-body').html(content);

									Adzuki.Form.initAjaxForm('FreshdeskCreateTicket');
									Adzuki.DragDropUpload.init($('#freshdeskcreateticket-files'));
									Adzuki.DragDropUpload.start($(".file-upload-options"));

									$('.submit-ticket').html('<i class="adzicon-event_ticket fas fa-fw fa-ticket-alt"></i> Email Care Team');

									$modal.on('hidden.bs.modal', function _restoreModal() {
										$modal.removeClass('wide').off('hidden.bs.modal');
									}).modal('show');
								});
						} else {
							Adzuki.StatusMessage('Error', 'Unable to create screenshot from current page.', 'Invalid Screenshot');
						}
					});
				});
			}
		});

		// submit a finance ticket
		$('.submit-finance-ticket').on('click', function _openFinanceTicket(e) {
			var $modal         = $('.modal'),
				support_id     = $(this).data('support-id'),
				environment    = $(this).data('environment'),
				resolution     = screen.width + 'x' + screen.height,
				reservation_id = ($(this).data('reservation-id') === undefined ? '' : $(this).data('reservation-id'));

			e.preventDefault();

			Adzuki.Ajax.get('/Freshdesk/createFinanceTicket/' + support_id + '/' + environment + '/' + resolution + '/' + reservation_id)
			.then(function _showFinanceTicketScreen(content) {
				$modal.find('.modal-title').text("Email Commission Team");
				$modal.find('.modal-body').html(content);

				Adzuki.Form.initAjaxForm('FreshdeskCreateFinanceTicket');
				Adzuki.DragDropUpload.init($('#freshdeskcreatefinanceticket-files'));
				Adzuki.DragDropUpload.start($(".file-upload-options"));

				$('.submit-finance-ticket:not(.no-money-icon)').html('<i class="adzicon-money fas fa-fw fa-money-bill-alt"></i> Email Commission Team');

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$('.global-search-new').on('click', '.global-search-item', function _globalSearchItem(e) {
			var item     = $(this).data('content'),
				redirect = Adzuki.base_uri + '/Searches/globalSearchHistory/' + encodeURIComponent(JSON.stringify(item));

			e.preventDefault();

			window.open(redirect, item.target);
		});

		$('.global-search-new').on('click', '.global-search-close', function _globalSearchClose(e) {
			e.preventDefault();

			$('.global-search-blanket').css('display', 'none');
			$('.global-search-container').css('display', 'none');
			$('.global-search-new').html('');
			$('.global-search').val('');
		});


		/**
		 * Function to handle the external link to the MediaHub application.
		 * Find the existing form on the page and store the input data into localStorage to load Later.
		 * Then redirect the user to the MediaHub application.
		 */

		$('.mediahub-link').on('click', function saveFormRedirect(e) {
			e.preventDefault();

			//  Get the form, set the redirect Url from the href, and create a storageKey name for localStorage
			const form         = document.querySelector('form');
			const redirectUrl  = $(this).attr('href');
			const storageKey   = Adzuki.agent_id + '-' + form.name +'Form';

			if (form) {
				// Create the data object and find retrieve the input elements
				const formData = {};
				const formElements = form.querySelectorAll('input, select, textarea');

				formElements.forEach(element => {
					if (element.name && element.value) {
						if (element.type === 'checkbox' || element.type === 'radio') {
							if (element.checked) {
								formData[element.name] = element.value;
							}
						} else if (element.type === 'date') {
							formData[element.name] = element.value || null;
						} else {
							formData[element.name] = element.value;
						}
					}
				});


				localStorage.setItem(storageKey, JSON.stringify(formData));
			}

			// Redirect user to the correct media hub page
			 window.location.href = redirectUrl;
		});

	});

	// header global search
	function initGlobalSearch()
	{
		if ($('.global-search').length > 0) {
			if (Adzuki.app === 'HomeOffice') {
				Adzuki.Typeahead(
					'.global-search',
					'/Searches/hoSearch',
					function select(item, $self, typeahead) {
						typeahead.setHiddenValue(item.id);

						_homeOfficeSelectItem(item);
					},
					function template(item) {
						return JSON.stringify(item);
					},
					null,
					function sorter(items) {
						return items;
					}
				);
			} else if (Adzuki.app === 'DestinationHub') {
				Adzuki.Typeahead(
					'.global-search',
					'/Searches/destinationhubSearch/',
					function select(item, $self, typeahead) {
						switch (item.result_type) {
							case 'recommendation':
								document.location = Adzuki.destinationhub_url + Adzuki.base_uri + '/Businesses/read/' + item.destination_hub_destination_id + '#recommendation-' + item.id;
								break;
							case 'business':
							case 'city':
								document.location = Adzuki.destinationhub_url + Adzuki.base_uri + '/Businesses/read/' + item.id;
								break;
							default:
								break;
						}
					},
					function template(item) {
						return JSON.stringify(item);
					}
				);
			} else {
				if (Adzuki.is_mobile === true || screen.width < 1024) { // eslint-disable-line no-lonely-if
					Adzuki.Typeahead(
						'.global-search',
						'/Searches/globalSearchAutoComplete/old/',
						function selectGlobalSearchItem(item) {
							if (item.url) {
								document.location = item.url;
							} else {
								document.location = Adzuki.base_uri + '/Searches/globalSearchHistory/' + encodeURIComponent(JSON.stringify(item));
							}
						},
						function template(item) {
							return JSON.stringify(item);
						},
						null,
						function sorter(items) {
							return items;
						}
					);
				} else {
					$('.global-search-new').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Searching...');
					globalSearchNew();
				}
			}
		}
	}

	function _homeOfficeSelectItem(item)
	{
		var url = Adzuki.homeoffice_url + Adzuki.base_uri + '/Franchises';

		switch (item.type) {
			case 'agent':
				url += '/agents/' + item.franchise_id + '/section_id:' + item.id ;
				document.location = url;
				break;
			case 'franchise':
				url += '/view/' + item.franchise_id;
				document.location = url;
				break;
			case 'website':
				url += '/websites/' + item.franchise_id + '/section_id:' + item.id;
				document.location = url;
				break;
			case 'reservation':
				url = Adzuki.homeoffice_url + Adzuki.base_uri + '/Searches/reservationFromGlobal/' + item.id;
				document.location = url;
				break;
			default:
				console.log("should never get here");
				break;
		}
	}

	function globalSearchNew()
	{
		$('.global-search').on('keyup', function _globalSearch(e) {
			var $self = $(this),
				term  = $self.val();

			executeSearch($self, term);
		});
	}

	debounce = function debounce(func, wait, immediate)
	{
		var timeout;
		return function _debounced() {
			var self = this, args = arguments;
			var later = function _later() {
				timeout = null;
				if (!immediate) {
					func.apply(self, args);
				}
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(self, args);
			}
		};
	};

	executeSearch = debounce(function executeSearch($obj, term)
	{
		var $self = $obj;

		if (term.length > 2) {
			$self.addClass('adzuki-typeahead');
			$self.addClass('ajax-spinner');

			$('.global-search-blanket').css('display', 'block');
			$('.global-search-container').css('display', 'inherit');

			Adzuki.Ajax.get('/Searches/globalSearchAutoComplete/new/' + term).then(function _globalSearchResults(response) {
				$('.global-search-new').html(response);

				$self.removeClass('adzuki-typeahead');
				$self.removeClass('ajax-spinner');
			});
		} else {
			$self.removeClass('adzuki-typeahead');
			$self.removeClass('ajax-spinner');

			$('.global-search-blanket').css('display', 'none');
			$('.global-search-container').css('display', 'none');
		}
	}, 500);

}(jQuery, window.Adzuki || {}));
